import { render } from "./BaseCharacter.vue?vue&type=template&id=43145fec"
import script from "./BaseCharacter.vue?vue&type=script&lang=js"
export * from "./BaseCharacter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__